import { render, staticRenderFns } from "./aspect-component.vue?vue&type=template&id=2845bb21&scoped=true&"
import script from "./aspect-component.vue?vue&type=script&lang=ts&"
export * from "./aspect-component.vue?vue&type=script&lang=ts&"
import style0 from "./aspect-component.vue?vue&type=style&index=0&id=2845bb21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845bb21",
  null
  
)

export default component.exports